import React, { useState } from "react";
import { Link } from "react-router-dom";
import LandingNav from "../components/landing/LandingNav";
import LandingFooter from "../components/landing/LandingFooter";
import FaqSection from "../components/landing/FaqSection";
import "../styles/saas.css";

const WHATSAPP_NUMBER = "918433803555";

export default function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "General Inquiry",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappText = `*New Inquiry from Beentara Website*%0A
*Name:* ${formData.firstName} ${formData.lastName}
*Email:* ${formData.email}
*Subject:* ${formData.subject}
*Message:* ${formData.message}`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappText}`, "_blank");
  };

  return (
    <div className="saas-landing-page">
      <LandingNav />

      <section className="saas-lp-section saas-lp-section--contact-hero">
        <div className="saas-lp-inner saas-lp-section__header">
          <p className="saas-lp-label">Get in Touch</p>
          <h2>We&apos;re here to help you grow</h2>
          <p>
            Whether you have a question about the Beentara ecosystem, need help migrating your data,
            or want to explore enterprise pricing, our team is ready.
          </p>
        </div>
      </section>

      <section className="saas-lp-section">
        <div className="saas-lp-inner saas-lp-contact">
          <div className="saas-lp-contact__info">
            <h3>Contact Information</h3>
            <p>Reach out to us directly through any of these channels.</p>

            <div className="saas-lp-contact__card">
              <strong>Email Us</strong>
              <p>Our friendly team is here to help.</p>
              <a href="mailto:hello@beentara.com">hello@beentara.com</a>
            </div>

            <div className="saas-lp-contact__card">
              <strong>Phone</strong>
              <p>Mon–Fri, 9am – 6pm IST</p>
              <a href="tel:+918433803555">+91 84338 03555</a>
            </div>

            <div className="saas-lp-contact__card">
              <strong>WhatsApp Support</strong>
              <p>Available Mon–Fri, 9am – 6pm IST.</p>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer">
                Message us directly →
              </a>
            </div>
          </div>

          <div className="saas-lp-contact__form-wrap">
            <h3>Send us a message via WhatsApp</h3>
            <form className="saas-form saas-lp-contact__form" onSubmit={handleSubmit}>
              <div className="saas-lp-contact__row">
                <label htmlFor="firstName">
                  First Name
                  <input id="firstName" value={formData.firstName} onChange={handleChange} required />
                </label>
                <label htmlFor="lastName">
                  Last Name
                  <input id="lastName" value={formData.lastName} onChange={handleChange} />
                </label>
              </div>
              <label htmlFor="email">
                Work Email
                <input id="email" type="email" value={formData.email} onChange={handleChange} required />
              </label>
              <label htmlFor="subject">
                Subject
                <select id="subject" value={formData.subject} onChange={handleChange}>
                  <option>General Inquiry</option>
                  <option>Sales &amp; Pricing</option>
                  <option>Technical Support</option>
                  <option>Partnerships</option>
                </select>
              </label>
              <label htmlFor="message">
                Message
                <textarea id="message" rows={5} value={formData.message} onChange={handleChange} required />
              </label>
              <button type="submit" className="saas-btn saas-btn--whatsapp">
                Send via WhatsApp
              </button>
            </form>
          </div>
        </div>
      </section>

      <FaqSection />
      <LandingFooter />
    </div>
  );
}
